import type { SrCustomerStatus } from '@plato/data/starrocks/types';

export type SearchMatchType = 'exact' | 'almost';

export type CustomerSearchRow = {
    id: string;
    erp_id: string;
    name: string;
    status?: SrCustomerStatus;
    updated_at: string;
    line1?: string;
    line2?: string;
    line3?: string;
    street?: string;
    zip_code?: string;
    city?: string;
    country_code?: string;
    match_type: SearchMatchType;
};

export type ProductSearchRow = {
    id: string;
    product_variant_id: string;
    product_variant_name: string;
    article_group_id: string;
    article_group_name: string;
    ean: string;
    gtin: string;
    package_unit: string;
    parts_list_type: string;
    status: string;
    partial_packing_type: string;
    updated_at: string;
    supplier_id: string;
    supplier_name: string;
    purchase_order_number: string;
    match_type: SearchMatchType;
    quantity_unit_sales?: string | null;
    sales_units_per_package_unit?: number | null;
};

export type SalesOrderSearchRow = {
    id: string;
    erp_id: string;
    type: string;
    document_type: string;
    customer_id: string;
    customer_name?: string;
    updated_at: string;
    match_type: SearchMatchType;
};

export enum SearchEntity {
    Product = 'product',
    Customer = 'customer',
    SalesOrder = 'sales_order',
    SalesQuote = 'sales_quote',
}

export enum GlobalSearchTab {
    All = 'all',
    Customers = 'customers',
    Orders = 'sales_orders',
    Quotes = 'sales_quotes',
    Products = 'products',
}

export const SearchEntityTab = {
    [SearchEntity.Customer]: GlobalSearchTab.Customers,
    [SearchEntity.SalesOrder]: GlobalSearchTab.Orders,
    [SearchEntity.SalesQuote]: GlobalSearchTab.Quotes,
    [SearchEntity.Product]: GlobalSearchTab.Products,
} as const;

export const SearchEntityRoute = {
    [SearchEntity.Customer]: '/customers',
    [SearchEntity.SalesOrder]: '/orders',
    [SearchEntity.SalesQuote]: '/quotes',
    [SearchEntity.Product]: '/products',
} as const;

type CustomerSearchEntity = {
    entity: SearchEntity.Customer;
} & CustomerSearchRow;

type OrderSearchEntity = {
    entity: SearchEntity.SalesOrder;
} & SalesOrderSearchRow;

type QuoteSearchEntity = {
    entity: SearchEntity.SalesQuote;
} & SalesOrderSearchRow;

type ProductSearchEntity = {
    entity: SearchEntity.Product;
} & ProductSearchRow;

export type SearchEntityItemData = {
    [SearchEntity.Customer]: CustomerSearchEntity;
    [SearchEntity.SalesOrder]: OrderSearchEntity;
    [SearchEntity.SalesQuote]: QuoteSearchEntity;
    [SearchEntity.Product]: ProductSearchEntity;
};
